import React from "react";

function FoodSafetyDefenseField({haccpArr}){
	let passedValues = haccpArr.haccpArr;
	return(
		passedValues.map( (passedValue) =>(
			<tr>
				<td>{passedValue["hazard"]}</td>  
				<td>{passedValue["control"]}</td>
				<td>{passedValue["processing_step"]}</td>
			</tr>
		))
	)
}

export default FoodSafetyDefenseField;